export enum TrialProduct {
    AlphaBrain = "ab",
    TotalHuman = "th",
    NewMood = "nm",
    ShroomTechSport = "sts"
}

export interface Trial {
    btnTitle: string;
    btnImageParams: string;
    title: string;
    description: string;
    img: string;
    imgAltText: string;
    quote: string;
    author: string;
    productSlug: string;
    productId: number;
    trialSlug: string;
    trialProductId: number;
}

type Trials = {
    [key in TrialProduct]: Trial;
};

export const trials: Trials = {
    [TrialProduct.AlphaBrain]: {
        btnTitle: 'Alpha BRAIN<span class="oui-sup" aria-hidden="true">®</span>',
        btnImageParams: "trim=auto&w=256&h=256&bg=ffffff&fit=crop&fp-z=1.5&crop=focalpoint",
        title: 'Alpha BRAIN<span class="oui-sup" aria-hidden="true">®</span>',
        description: 'Alpha BRAIN<span class="oui-sup">®</span> is Onnit\'s flagship supplement—a nootropic that helps support cognitive functions, including mental focus, reaction time, and the ability to think clearly under stress.<span class="oui-sup">†</span>  Since launching in 2010, more than three and a half-million bottles have been sold.',
        img: 'Rogan-Trial-Page-Quote.jpg',
        imgAltText: 'Joe Rogan speaking about Alpha BRAIN<span class="oui-sup" aria-hidden="true">®</span>.',
        quote: 'Most of the things that I do require me to have a good memory, to be sharp, to be thinking about things clearly.  Alpha BRAIN<span class="oui-sup" aria-hidden="true">®</span> is the very best thing I\'ve ever found that helps me with that and I think most people could benefit from it.',
        author: 'Joe Rogan',
        productSlug: 'alpha-brain',
        productId: 32,
        trialSlug: 'alpha-brain-trial',
        trialProductId: 8559,
    },
    [TrialProduct.TotalHuman]: {
        btnTitle: 'Total Human<span class="oui-sup" aria-hidden="true">®</span>',
        btnImageParams: "trim=auto&w=256&h=256&bg=ffffff&fit=crop&fp-z=1.5&crop=focalpoint",
        title: 'Total Human<span class="oui-sup" aria-hidden="true">®</span>',
        description: 'Total Human<span class="oui-sup" aria-hidden="true">®</span> is a re-imagining of the daily multivitamin, offering day and night packs that provide the right nutrition your body needs at the times it needs it most. The Day Pack aims to help you be alert in the morning, focused at work, and energized for physical activity, while the Night Pack assists with winding down and sleeping soundly.<span class="oui-sup">†</span>',
        img: '2023-Free-Trial-Update-WPage-TH.png',
        imgAltText: 'Man playing rugby.',
        quote: "Great, convenient packets! I used to have several bottles of supplements on my counter. I would have to guess what I needed, and how much/many to take. These packets take out the guess work. The night support is my favorite.",
        author: 'Jeff F.',
        productSlug: 'total-human',
        productId: 8282,
        trialSlug: 'total-human-trial',
        trialProductId: 8503,
    },
    [TrialProduct.NewMood]: {
        btnTitle: 'New MOOD<span class="oui-sup" aria-hidden="true">®</span>',
        btnImageParams: "trim=auto&w=256&h=256&bg=ffffff&fit=crop&fp-z=1.5&crop=focalpoint",
        title: 'New MOOD<span class="oui-sup" aria-hidden="true">®</span>',
        description: 'Great for unwinding after a long day at work, or helping to support a normal daily stress response. New MOOD<span class="oui-sup" aria-hidden="true">®</span> is like a deep breath and a smile in a bottle.<span class="oui-sup">†</span>',
        img: '2023-Free-Trial-Update-WPage-NM.png',
        imgAltText: 'Neen Williams working out.',
        quote: 'Does what it says it does, love this product, on my 2nd bottle now. Glad I gave it a try.',
        author: 'Sean Wigman',
        productSlug: 'new-mood',
        productId: 46,
        trialSlug: 'offer/aff/new-mood/',
        trialProductId: 3104,
    },
    [TrialProduct.ShroomTechSport]: {
        btnTitle: 'Shroom Tech<span class="oui-sup" aria-hidden="true">®</span> SPORT',
        btnImageParams: "trim=auto&w=256&h=256&bg=ffffff&fit=crop&fp-z=1.5&crop=focalpoint",
        title: 'Shroom Tech<span class="oui-sup" aria-hidden="true">®</span> SPORT<span class="oui-sup" aria-hidden="true">®</span>',
        description: 'Designed to support cardiovascular endurance, Shroom Tech<span class="oui-sup" aria-hidden="true">®</span> SPORT features cordyceps sinensis, a mushroom shown to aid energy utilization during exercise. Use it to go faster, longer, and get more reps in your workouts.<span class="oui-sup">†</span>',
        img: '2023-Free-Trial-Update-WPage-STS.png',
        imgAltText: 'Man and woman lifting kettlebells',
        quote: "You won't know it worked until after your workout, when you'll think, 'D*mn that was easier than it usually is.'",
        author: 'Svenotto Fishmo',
        productSlug: 'shroomtech-sport',
        productId: 4448,
        trialSlug: 'shroom-tech-sport-offer',
        trialProductId: 4326,
    }
};
